module.exports = __webpack_public_path__ + "img/kiosk.0b431307.png";